var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57575_28151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.66912 5.66826 0.5 12 0.5C18.3309 0.5 23.5 5.66826 23.5 12C23.5 18.3309 18.3317 23.5 12 23.5C5.66912 23.5 0.5 18.3317 0.5 12ZM0.90625 12C0.90625 18.1176 5.88243 23.0938 12 23.0938C18.1176 23.0938 23.0938 18.1176 23.0938 12C23.0938 5.88243 18.1176 0.90625 12 0.90625C5.88243 0.90625 0.90625 5.88243 0.90625 12Z",
    fill: "#12A8C4",
    stroke: "#12A8C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 18.9391L18.8926 12.0003L8.48438 5.06152V18.9391ZM9.89062 7.68909L16.3574 12.0003L9.89062 16.3115V7.68909Z",
    fill: "#ABEBF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57575_28151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.38fd25ec94defe511629657213ba7ff5.svg";
export { ForwardRef as ReactComponent };